import { render, staticRenderFns } from "./ProcessAllot.vue?vue&type=template&id=b1e9d7f8&scoped=true"
import script from "./ProcessAllot.vue?vue&type=script&lang=js"
export * from "./ProcessAllot.vue?vue&type=script&lang=js"
import style0 from "./ProcessAllot.vue?vue&type=style&index=0&id=b1e9d7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e9d7f8",
  null
  
)

export default component.exports